import React, { Component } from "react"
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import { Input, DatePicker, Select, TextArea,CheckerBox } from "../core";
import { connect } from 'react-redux'
import $ from 'jquery'
import ReactTooltip from 'react-tooltip'

import { msg } from '../../components/Notifications/MsgBox';

import {
    updateEvaluationModalAction,
    clearEvaluationModalAction,
    updateMR_VendorAction,
    clearMR_VendorAction,
    getMREvalAction,
    updateMR_DetailAction,
    updateMR_EvalAction,
    updateMR_EvalChangeAction
} from '../../redux/actions/MRAction'
import { MessageText } from "../../configs";

import {data_t_MR_EVAL} from '../../configs/datas'
import { Storage } from "../../configs";

class PanelEvaluation extends Component {

    constructor(props) {
        super(props)

        this.state = {
            //...props,
            transaction_no:'',
            temp_not_eval:null,
            temp_eval:[],
            temp_eval_con:[]
        }

        this.handleChange = this.handleChange.bind(this)

        this.no_evaluation_ref = React.createRef();
        this.genaral_evaluation_ref = React.createRef();
        this.consortium_evaluation_ref = React.createRef();
        this.handleCHageEvalType = this.handleCHageEvalType.bind(this)

        window.handleMREval = this.handleMREval.bind(this)
    }

    handleMREval(){
        this.addMREval()
    }
    async addMREval(){
        console.log('addMREval')
        const {t_MR_EVAL,t_PO_DETAIL,t_IR_DETAIL,t_MR_DETAIL} = this.props
        const role = Storage.getRole()
        let isAddMREval=false;
        if(
            role ==="C" 
            && (!t_MR_EVAL || ( t_MR_EVAL && t_MR_EVAL.length === 0) ) 
        )
            isAddMREval=true;

        if(
            role ==="R" 
            && (!t_MR_EVAL || ( t_MR_EVAL && t_MR_EVAL.length === 0) ) 
            && (t_IR_DETAIL && t_IR_DETAIL.length >0) 
        )
            isAddMREval=true;
        
        if(isAddMREval){
            let poNo=t_PO_DETAIL ? t_PO_DETAIL.po_contract_no : "";
            let taxRate=null;
            let taxCode=null;

            if(t_IR_DETAIL && t_IR_DETAIL.length > 0 )
            {
                taxCode = t_IR_DETAIL[0].tax_type;
                taxRate = this.props.masterVats.filter(f=>f.value === taxCode).length>0?this.props.masterVats.filter(f=>f.value === taxCode)[0].key1:0
            }

            await this.props.getMREval(poNo,taxRate,taxCode).then(response => {
                if(response && response.data && !response.data.isSuccess){
                    msg.error(response.data.message)
                    this.props.updateMR_Eval(null);
                    return;
                }

                const ref = response.data.data;
                let mrList =[];
                let header=data_t_MR_EVAL[0];
                header.evaluation_type=ref.evaluation_type;
                header.is_new_evaluation=ref.is_new_evaluation;
                header.po_vendor_code=ref.po_vendor_code;
                header.po_vendor_name=ref.po_vendor_name;
                header.is_enrgy = ref.is_enrgy;
                header.prNo = ref.prNo;

                if(ref.pr_data){
                    header.command_method = ref.pr_data.command_method;
                    header.command_type = ref.pr_data.command_type;
                    header.is_sshe = ref.pr_data.is_sshe;
                    header.p_net_price=ref.pr_data.p_net_price ?  ref.pr_data.p_net_price : 0;
                    header.s_net_price=ref.pr_data.s_net_price ?  ref.pr_data.s_net_price : 0;
                    header.net_price=header.p_net_price + header.s_net_price;
                    header.procmethod_cat = ref.pr_data.procmethod_cat;
                    header.amount = ref.pr_data.amount;
                    header.tax_rate = ref.pr_data.tax_rate;
                    header.tax_code = ref.pr_data.tax_code;
                }

                if(ref.evaluation_data==null || ref.evaluation_data.length==0){

                    if(ref.pr_data){
                        let pr=ref.pr_data
                        header.command_method = pr.command_method;
                        header.command_type = pr.command_type;
                        header.procmethod_cat = pr.procmethod_cat;
                        header.amount = pr.amount;
                        header.tax_rate = pr.tax_rate;
                        header.tax_code = pr.tax_code;
                        header.is_enrgy = pr.is_enrgy;
                        // header.is_sshe = pr.is_sshe;
                        header.p_net_price = pr.p_net_price;
                        header.s_net_price = pr.s_net_price;
                        header.net_price=pr.p_net_price + pr.s_net_price;
                    }

                    mrList.push(header)
                }
                else{
                    for (let index = 0; index<ref.evaluation_data.length; index++) {
                        let row = ref.evaluation_data[index]
                        let tempRow = {};

                        tempRow.evaluation_type=header.evaluation_type;
                        tempRow.is_new_evaluation=header.is_new_evaluation;
                        tempRow.p_net_price=header.p_net_price;
                        tempRow.po_vendor_code=header.po_vendor_code;
                        tempRow.po_vendor_name=header.po_vendor_name;
                        tempRow.prNo = header.prNo;
                        if(ref.pr_data){
                            tempRow.command_method = header.command_method;
                            tempRow.command_type = header.command_type;
                            tempRow.procmethod_cat = header.procmethod_cat;
                            tempRow.amount = header.amount;
                            tempRow.tax_rate = header.tax_rate;
                            tempRow.tax_code = header.tax_code;
                            tempRow.is_enrgy = header.is_enrgy;
                            tempRow.is_sshe = header.is_sshe;
                            tempRow.p_net_price = header.p_net_price;
                            tempRow.s_net_price = header.s_net_price;
                            tempRow.net_price=header.p_net_price + header.s_net_price;
                        }
                        tempRow.form = row.form;
                        tempRow.form_name = row.form_name;
                        tempRow.vendor_code = row.vendor_code;
                        tempRow.vendor_name = row.vendor_name;
                        tempRow.evaluator_code = row.evaluator_code;
                        tempRow.evaluator_name = row.evaluator_name;
                        tempRow.mr_doc_no  = row.mr_doc_no;
                        mrList.push(tempRow)
                    }
                }

                
                this.props.updateMR_Eval(mrList);
            }).catch(error => {
                if (error.message) {
                    
                    if (error.message.indexOf("timeout") > -1) {
                        msg.error("ไม่สามารถแนะนำแบบประเมินผู้ค้าได้")
                    }
                    else {
                        msg.error(error.message)
                    }
                   

                }
                else {
                    msg.error("ไม่สามารถดึงข้อมูลแบบประเมิน")
                }

            });
        }
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;
        const value = event.target.value;
        if(name =="evaluation_type"){
            this.handleCHageEvalType(value);
        }

        this.props.handleChange(event);
    }

    handleCHageEvalType(value){
        const oldValue = this.props.t_MR_DETAIL.evaluation_type;
        let mrVendor = [];
        let reason_id = null;

        if(oldValue =="genaral_evaluation"){
            this.setState({
                ...this.state,
                temp_eval:this.props.t_MR_VENDOR,
            })
        }
        else if(oldValue =="consortium_evaluation"){
            this.setState({
                ...this.state,
                temp_eval_con:this.props.t_MR_VENDOR
            })
        }
        else if(oldValue =="no_evaluation"){
            this.setState({
                ...this.state,
                temp_not_eval:this.props.t_MR_DETAIL.reason_id,
            })
        }


        if(value =="genaral_evaluation"){

            mrVendor = this.state.temp_eval;
            reason_id = null;
        }
        else if(value =="consortium_evaluation"){
            mrVendor = this.state.temp_eval_con;
            reason_id = null;
        }
        else if(value =="no_evaluation"){
            mrVendor = [];
            reason_id = this.state.temp_not_eval;
        }

        this.props.updateMR_EvalChange(reason_id !== undefined?reason_id:null,mrVendor);
    }

    toBoolean(value) {
        if (value === 1)
            return true
        else if (value === true)
            return true
        else
            return false
    }

    openSearchEmployeeModal() {
        
        window.$('#searchEmployeeModal').modal('show');

    }

    async openAddConsortiumModal() {
        
        let {
            t_PO_DETAIL,
            t_MR_DETAIL,
            mrForms,
            mrVendortypes,
            t_PO_COMMITTEE,
            t_MR_EVAL
        } = this.props;

        await this.props.clearEvaluationModal();
        
        await this.props.updateEvaluationModal({
            ...this.props.evaluationModal,
            evaluation_form_name: mrForms[0].forM_ID,
            vendor_group: mrVendortypes[0].vendoR_TYPE_CODE
        });

        if (t_MR_DETAIL.evaluation_type === "genaral_evaluation") {
            let evaId = t_MR_DETAIL.receiver_code
            let evaName = t_MR_DETAIL.receiver_name

            if(t_PO_COMMITTEE && t_PO_COMMITTEE.length > 0 && t_PO_COMMITTEE[0].code){
                evaId = t_PO_COMMITTEE[0].code
                evaName = t_PO_COMMITTEE[0].fullname
            }            
            if(t_MR_DETAIL.eval_code){
                evaId = t_MR_DETAIL.eval_code
                evaName = t_MR_DETAIL.eval_name
            }

            await this.props.updateEvaluationModal({
                ...this.props.evaluationModal,
                vendor_code: t_PO_DETAIL.vendor_code,
                vendor_name: t_PO_DETAIL.vendor_name,
                //index:"",
                evaluator_id: evaId,
                evaluator_name: evaName,

            });
        }
        if(t_MR_DETAIL.evaluation_type === "consortium_evaluation"){

            await this.props.updateEvaluationModal({
                ...this.props.evaluationModal,
                evaluator_id: t_MR_DETAIL.eval_code,
                evaluator_name: t_MR_DETAIL.eval_name,

            });
        }

        window.$('#addConsortiumModal').modal('show');

    }

    openEditConsortiumModal(data,index) {

        this.props.clearEvaluationModal();

        this.props.updateEvaluationModal({...data,index:index});

        window.$('#addConsortiumModal').modal('show');

    }

    openEvalModal() {
        
        window.$('#addEvaluationModal').modal('show');

    }

    openDeleteConsortiumModal(data,index) {
        msg.showConfirm(
            "Confirm",
            MessageText.PAGE.MR.POPUP_MSG_CONFIRM_DELETE_EVA,
        ()=>{
           msg.hideConfirm()
           this.props.removeMR_Vendor('remove',index);
           msg.success(MessageText.PAGE.MR.POPUP_MSG_SUCCESS_DELETE_EVA)
        },
        ()=>{
            msg.hideConfirm()
            console.log("ยกเลิกการลบรายการประเมิน")
        },
        ()=>{
            console.log("ยกเลิกการลบรายการประเมิน")
        }
        )
    }

    renderEvaluationAddButton() {
        let { t_MR_DETAIL, t_MR_VENDOR } = this.props;

        if ((t_MR_DETAIL.evaluation_type === "genaral_evaluation" && t_MR_VENDOR.length === 0)
            || (t_MR_DETAIL.evaluation_type === "consortium_evaluation")
        )
        {
            return (
                <Button className="sp-bt-addmore" onClick={() => this.openAddConsortiumModal()}>
                    <i className="icon btn-plus" />
                    <span>เพิ่ม</span>
                </Button>
            )
        }
        else
            return ''
    }

    renderEvaluationPanel(){

        let { t_MR_DETAIL, t_MR_VENDOR, viewMode,mrReason,t_MR_EVAL } = this.props;

  

        if (t_MR_DETAIL.evaluation_type === "no_evaluation") {
            return <div style={{marginLeft:20}}>
                <h2 className="rrs-table-hdr"><span className="required">*</span>&nbsp;กรุณาระบุเหตุผล</h2>
                <div style={{marginBottom:15}}>
                    <Select
                        key={`reason_id`}
                        name="reason_id"
                        value={t_MR_DETAIL.reason_id}
                        onChange={(event) => this.handleChange(event)}
                        viewMode={viewMode}
                    >
                        <option value={0}>กรุณาเลือกเหตุผล</option>
                        {mrReason && mrReason.map((data, index) => (
                            <option
                                key={index+1}
                                value={data.reason_id}>
                                {data.reason_name}
                            </option>
                        )
                        )}

                    </Select>
                </div>
                
            </div>;
        }
        else if(t_MR_DETAIL.evaluation_type !== null)
        {
          
            return <React.Fragment>
                <div className="sp-table-container">
                    <div className="row rrs-table-hdr-wrap mt-0">
                        {/* <div className="col"><h2 className="rrs-table-hdr">
                            {(t_MR_DETAIL.evaluation_type === "genaral_evaluation") ? "ประเมินใหม่" : "ประเมินแบบ กลุ่มผู้ค้าหลายราย (Consortium)"}
                        </h2></div> */}
                    </div>
                    {
                    (t_MR_DETAIL.is_enrgy !== null) &&
                    <div className="rrs-form col" style={{paddingTop:10}}  >
                        <p style={{marginBottom:0,marginRight:500}} ref={ref => this.docFrom = ref} data-tip='
กรณีคลิกเลือก &#10003; จะปรากฏคำถามด้านการจัดการพลังงานในแบบประเมินผู้ค้า 
ทั้งนี้ หากเป็นงานจัดหาที่ไม่เกี่ยวข้องกับระบบจัดการพลังงาน ไม่ต้องคลิกเลือก &#10003; ในช่องดังกล่าว
                        '></p>
                        <CheckerBox
                            name="is_enrgy"
                            checked={t_MR_DETAIL.is_enrgy}
                            viewMode={viewMode || (t_MR_VENDOR && t_MR_VENDOR.length > 0)}
                            onChange={(event) => this.handleChange(event)}
                            style={{marginBottom:2,paddingLeft:2}}
                        />
                        <label className="rrs-label">เป็นงานจัดหาที่เกี่ยวข้องกับระบบการจัดการพลังงาน</label>
                        <div className="icon-info"
                            onMouseOver={() => { ReactTooltip.show(this.docFrom) }}
                            onMouseLeave={() => { ReactTooltip.hide(this.docFrom) }}></div>
                        <ReactTooltip html={true} />
                    </div>}
                    <div className="row sp-pagination-control-top">
                        <div className="col-auto create-button">
                            { 
                             this.renderEvaluationAddButton()   
                            }
                        </div>
                    </div>
                </div>
                <div className="sp-table-container">
                    <div className="row no-gutters sp-table-content">
                        <table className="sp-table table rrs-table-2">
                            <thead>
                                <tr className="sp-table-header">
                                    { viewMode === false && (
                                        <React.Fragment>
                                            <th className="th-table"><div className="th-text text-center">Delete</div></th>
                                            <th className="th-table"><div className="th-text text-center">Detail</div></th>
                                        </React.Fragment>)
                                    }                                    
                                    <th className="th-table"><div className="th-text">Vendor Code.</div></th>
                                    <th className="th-table"><div className="th-text">Vendor Name</div></th>
                                    <th className="th-table"><div className="th-text">ใช้ชุดแบบสอบถาม</div></th>
                                    <th className="th-table"><div className="th-text">กลุ่มทะเบียนการค้า</div></th>
                                    <th className="th-table"><div className="th-text">ผู้ประเมิน</div></th>
                                </tr>
                            </thead>
                            <tbody>
                                
                                {
                                    t_MR_VENDOR.length === 0 && (
                                        <tr>
                                        <td colSpan="7"> <p>ไม่มีรายการ</p> </td>
                                        </tr>
                                    )
                                }

                                {
                                   
                                    t_MR_VENDOR && t_MR_VENDOR.length > 0 && t_MR_VENDOR.map((data, index) => (
                                        
                                    <tr key={index}>
                                        {viewMode === false && (
                                            <React.Fragment>
                                                <td className="text-center">
                                                    <a ><i className="icon btn-trash" style={{cursor:"pointer"}} onClick={() => this.openDeleteConsortiumModal(data, index)} /></a>
                                                </td>                                                
                                                <td className="text-center">
                                                    <a ><i className="icon bt-edit" style={{cursor:"pointer"}} onClick={() => this.openEditConsortiumModal(data, index)} /></a>
                                                </td>
                                            </React.Fragment>)
                                        }
                                        <td> {data.vendor_code} </td>
                                        <td> {data.vendor_name} </td>
                                        <td> 
                                                {
                                                    this.props.mrForms && this.props.mrForms.length > 0 && this.props.mrForms.map((form, index) => {

                                                               if (form.forM_ID === Number(data.evaluation_form_name)) {
                                                            return form.forM_NAME
                                                        }
                                                    })
                                                }
                                                {/* {data.evaluation_form_name}  */}
                                            </td>
                                        <td>
                                            {
                                                this.props.mrVendortypes &&this.props.mrVendortypes.length>0 && this.props.mrVendortypes.map((vendor, index) => {
                                                    if (vendor.vendoR_TYPE_CODE + "" === data.vendor_group) {
                                                        if( data.vendor_group === "")
                                                            return "-"
                                                        else
                                                            return vendor.vendoR_TYPE_NAME
                                                    }
                                                })
                                            }
                                            {/* {data.vendor_group} */}
                                        </td>
                                        <td> {data.evaluator_name} </td>
                                        {/* {viewMode === false && (
                                            <React.Fragment>
                                                <td className="text-center">
                                                    <a ><i className="icon btn-edit" onClick={() => this.openEditConsortiumModal(data, index)} /></a>
                                                </td>
                                                <td className="text-center">
                                                    <a ><i className="icon btn-trash" onClick={() => this.openDeleteConsortiumModal(data, index)} /></a>
                                                </td>
                                            </React.Fragment>)
                                        } */}


                                    </tr>
                                ))}  
                                
                            </tbody>
                        </table>
                    </div>
                </div>
            </React.Fragment>
        }
            
    }

    componentWillReceiveProps(nextProps) {

        // console.log("PanelEvaluation-componentWillReceiveProps()");
        if (this.state.transaction_no !== nextProps.t_MR_DETAIL.transaction_no) {
    
            if(nextProps.t_MR_DETAIL.transaction_no){
                    this.setState({
                        transaction_no: nextProps.t_MR_DETAIL.transaction_no
                    })

            }else{
                // console.log("nextProps.t_MR_DETAIL.transaction_no is null!")
            }

        }
        
        
    }

    
    componentDidMount() {
        // console.log("PanelEvaluation-componentDidMount()");
        // console.log( this.props.transaction)
    }

    render() {

        let { t_MR_DETAIL, viewMode , t_MR_EVAL } = this.props;

        
        return (
            <React.Fragment>

            <div>
                <div>
                    <Grid container >
                        <h3 className="rrs-sub-header" style={{textAlign: 'left'}}>การประเมินผู้ค้า</h3>
                        {
                        (t_MR_EVAL && t_MR_EVAL.length > 0) &&
                        (<a style={{marginTop:24,marginLeft:10,cursor:"pointer"}}>
                            <i className="icon icon-tasks-ongoing" onClick={() => this.openEvalModal()} />
                        </a>)
                        }
                    </Grid>
                </div>
                <div style={{
                    paddingTop: '25px',
                    borderRadius: '15px',
                    border: '1px solid',
                    borderColor: '#a4a4a6',
                    paddingBottom: "15px",
                    paddingLeft: '15px',
                    paddingRight: '15px',
                    marginLeft:-15,
                    marginRight:-15,
                    marginBottom:20
                }}>
                    <div className="row mt-0 mx-0">
                    <div className="rrs-form col">
                        <label htmlFor="cc" className="rrs-label"><span className="required">*</span> ตัวเลือกการประเมิน</label>
                        <div className="rrs-detail-data">
                            <div className="row">
                                <div className="col-auto">
                                    <label className={`radiocontainer ${viewMode?'':'clickable'}`}>ไม่มีการประเมิน
                                        <input
                                            type="radio"
                                            name="evaluation_type"
                                            defaultValue="no_evaluation"
                                            checked={(t_MR_DETAIL.evaluation_type === "no_evaluation")}
                                            onChange={this.handleChange}
                                            ref={this.no_evaluation_ref}
                                            disabled={viewMode}
                                        />
                                        <span className="checkmark" />
                                    </label>
                                </div>
                                <div className="col-auto">
                                    <label className={`radiocontainer ${viewMode?'':'clickable'}`}>ประเมินผู้ค้ารายเดียว
                                        <input
                                            type="radio"
                                            name="evaluation_type"
                                            defaultValue="genaral_evaluation"
                                            checked={(t_MR_DETAIL.evaluation_type === "genaral_evaluation")}
                                            onChange={this.handleChange}
                                            ref={this.genaral_evaluation_ref}
                                            disabled={viewMode}
                                        />
                                        <span className="checkmark" />
                                    </label>
                                </div>
                                <div className="col-auto">
                                    <label className={`radiocontainer ${viewMode?'':'clickable'}`}>ประเมินผู้ค้าหลายราย (Consortium)
                                        <input
                                            type="radio"
                                            name="evaluation_type"
                                            defaultValue="consortium_evaluation"
                                            checked={(t_MR_DETAIL.evaluation_type === "consortium_evaluation")}
                                            onChange={this.handleChange}
                                            ref={this.consortium_evaluation_ref}
                                            disabled={viewMode}
                                        />
                                        <span className="checkmark" />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    {this.renderEvaluationPanel()}
                </div>
            </div>
                

            </React.Fragment>
        )
    }
}


const mapStateToProps = state => {
    const { MainRedux,MasterRedux } = state
    return { 
        evaluationModal: MainRedux.evaluationModal,
        mrForms: MasterRedux.mrForms,
        mrVendortypes: MasterRedux.mrVendortypes,
        mrReason: MasterRedux.mrReason,
        
        t_PO_DETAIL:MainRedux.t_PO_DETAIL,
        t_MR_DETAIL:MainRedux.t_MR_DETAIL,
        t_MR_VENDOR:MainRedux.t_MR_VENDOR,
        t_PO_COMMITTEE: MainRedux.t_PO_COMMITTEE,
        t_IR_DETAIL:MainRedux.t_IR_DETAIL,
        t_MR_EVAL:MainRedux.t_MR_EVAL,
        masterVats: MasterRedux.masterVats,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        clearEvaluationModal:() =>  dispatch(clearEvaluationModalAction()),
        updateEvaluationModal:(data) =>  dispatch(updateEvaluationModalAction(data)),
        updateMR_Vendor:(data) =>  dispatch(updateMR_VendorAction(data,'','')),
        removeMR_Vendor:(data,index) => dispatch(updateMR_VendorAction(data,index,'')),
        clearMR_Vendor:() =>  dispatch(clearMR_VendorAction()),
        getMREval:(poNo,taxRate,taxCode)=> dispatch(getMREvalAction(poNo,taxRate,taxCode)),
        updateMR_Detail: (data, fieldName) => dispatch(updateMR_DetailAction(data, fieldName)),
        updateMR_Eval: (data) => dispatch(updateMR_EvalAction(data)),
        updateMR_EvalChange: (reason_id,vendor) => dispatch(updateMR_EvalChangeAction(reason_id,vendor))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PanelEvaluation)